import React from 'react';
import CommonOperationScreen from '../../components/CommonOperationScreen/CommonOperationScreen';

const Shower = () => {
	return (
		<CommonOperationScreen operationName="SHOWER" buttonLabel="Mark SHOWER Complete" />
	);
};

export default Shower;
